export const divideToInt = (number, divider) => {
  if (!number || !divider) return 0;
  else return Math.round(number / divider);
};
